import { createContext, useContext } from "react"

const ActiveClientOrderContext = createContext(false)
export default ActiveClientOrderContext

export const useActiveClientOrder = () => useContext(ActiveClientOrderContext)
